function toggleCustomSelectLabelState($selectWrapper, flag = false) {
    const methodName = flag ? 'removeClass' : 'addClass';

    $selectWrapper[methodName]('custom-select-wrapper--empty');
}

export function initCustomSelect() {
    $('.js-custom-select').each((key, elem) => {
        const select = $('select', elem);
        const currentValue = select.val();

        toggleCustomSelectLabelState($(elem), Boolean(currentValue));

        select.select2({
            minimumResultsForSearch: -1,
            width: '100%',
        });

        $(elem).on('change', ({ target: { value } }) => {
            toggleCustomSelectLabelState($(elem), Boolean(value));
        });
    });
}
